import { message, Space, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useContactStore } from '../../hooks/useContactStore';
import { apiInstance } from '../../utils/api.js';
import { logUserAction } from '../../utils/logger';
import { getBlobFromUrl } from '../../utils/urlImgToBlob.js';
import EmployeeCard from './components/EmployeeCard';
import EmployeeForm from './components/EmployeeForm';

const EmployeePage = () => {
  const { id } = useParams();
  const { currentContactStore } = useContactStore();

  const { push } = useHistory();
  const isNewEmployee = !id;
  const [imageUrl, setImageUrl] = useState();
  const [employee, setEmployee] = useState({});
  const [cards, setCards] = useState([]);
  const [requests, setRequests] = useState([]);
  const [blobContent, setBlobContent] = useState(null);
  const [imageBlobType, setImageBlobType] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setErrors] = useState([]);

  const [reference, setReference] = useState({ PlantEmployee: [] });
  const [isLoading, setIsLoading] = useState(true);

  const removePhoto = () => {
    setEmployee((prev) => ({
      ...prev,
      attachFile1: null,
      attachFileName1: null,
    }));
    return true; // Возвращаем true, чтобы удаление прошло успешно
  };

  const fetchData = async () => {
    try {
      const response = await apiInstance(
        `${process.env.REACT_APP_API_URL}/api/crm/get-data?type=contacts`
      );

      const foundEmployee = response.rows.find((e) => e.Id === id);

      // console.log(foundEmployee);

      if (foundEmployee) {
        // Получаем первое вложение типа image

        if (foundEmployee.RespPhotoId.value) {
          const photoUrl = `${process.env.REACT_APP_API_URL}/api/files?fileId=${foundEmployee.RespPhotoId.value}&type=employee`;
          const { blob: photoBlob } = await getBlobFromUrl(photoUrl);
          setImageUrl(URL.createObjectURL(photoBlob));
          const reader = new FileReader();
          reader.onloadend = () => {
            setBlobContent(reader.result);
          };
          reader.readAsDataURL(photoBlob);

          if (photoBlob.type === 'image/jpeg' || photoBlob.type === 'image/png') {
            setImageBlobType(true);
          }
        }

        let contactCard = null;
        try {
          const cardResponse = await apiInstance(
            `${process.env.REACT_APP_API_URL}/api/crm/get-data?type=contact-card&contactId=${foundEmployee.Id}`
          );
          contactCard = cardResponse.rows?.length ? cardResponse.rows[0] : null;
          if (
            contactCard &&
            (contactCard.RespSCAStatus?.value === '25405d2a-9df4-47a9-9313-fc8b4ca329fa' ||
              contactCard.RespSCAStatus?.value === 'df17a6d7-2510-4a1e-9692-f9c34d66b156')
          ) {
            contactCard = null;
          }
        } catch (cardError) {
          console.warn('Не удалось получить картку сотрудника:', cardError);
        }

        const mappedEmployee = {
          ...foundEmployee,
          RespCardNumber: contactCard?.Name || '',
          RespCardId: contactCard?.Id || '',
          RespCardStatus: contactCard?.RespSCAStatus || null,
        };

        setEmployee(mappedEmployee);
      } else {
        message.error('Співробітника не знайдено');
        push('/employees');
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Помилка завантаження:', error);
      setIsLoading(false);
    }
  };

  const fetchCardsAndReference = async () => {
    try {
      setIsLoading(true);
      const [references, cards, requests] = await Promise.all([
        apiInstance(`${process.env.REACT_APP_API_URL}/api/requests/references`, 'GET'),
        apiInstance(`${process.env.REACT_APP_API_URL}/api/crm/get-data?type=cards`, 'GET'),
        apiInstance(
          `${process.env.REACT_APP_API_URL}/api/crm/get-data?id=sa3278462-sad322kj2ha1s-asd&type=requests`,
          'GET'
        ),
      ]);
      setReference(references);
      setCards(cards.rows || []);
      setRequests(requests.rows || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
      message.error('Ошибка получения данных');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchData();
    else setIsLoading(false);
    fetchCardsAndReference();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, currentContactStore]);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const formatPhoneNumber = (phoneNumber) => {
    // Добавляем проверку на наличие значения
    if (!phoneNumber) return '';

    // Убираем все нецифровые символы
    const cleaned = phoneNumber.toString().replace(/\D/g, '');

    // Форматируем номер как +38 (0XX) XXX-XX-XX
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 5)}) ${cleaned.slice(5, 8)}-${cleaned.slice(
      8,
      10
    )}-${cleaned.slice(10, 12)}`;
  };

  // Функция отправк
  const handleChangePhotoUpload = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    if (info.file.status === 'done') {
      // Читаем файл и конвертируем в base64
      const reader = new FileReader();
      reader.readAsDataURL(info.file.originFileObj);
      reader.onload = () => {
        setEmployee((prev) => ({
          ...prev,
          attachFile1: reader.result, // base64 строка
          attachFileName1: info.file.name,
        }));
        setLoading(false);
      };
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('Можна завантажувати лише JPG/PNG файли!');
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error('Розмір зображення не повинен перевищувати 10MB!');
    }
    return isJpgOrPng && isLt10M;
  };

  const handleSubmit = (employeeData) => {
    // Фильтруем данные перед отправкой
    const payloadCreate = {
      RespName: employeeData.RespName,
      RespSurName: employeeData.RespSurName,
      RespMobilePhone: employeeData.RespMobilePhone,
      RespEmail: employeeData.RespEmail,
      RespEmployeeJobId: employeeData.RespEmployeeJob,
      attachFile1: employee.attachFile1, // Берем из состояния
      attachFileName1: employee.attachFileName1, // Берем из состояния
    };
    console.log(employee, 'jkashdkjhaskjdhaskjdhkajshd', employeeData);
    const payloadUpdate = {
      Id: employee?.Id,
      needsCreate: true,
      RespCardSCA: employee?.RespCardNumber,
    };

    const url = isNewEmployee
      ? `${process.env.REACT_APP_API_URL}/api/post-data?type=create-employee`
      : `${process.env.REACT_APP_API_URL}/api/post-data?type=update-employee`;

    apiInstance(url, 'POST', isNewEmployee ? payloadCreate : payloadUpdate)
      .then(() => {
        logUserAction({
          action: isNewEmployee ? 'CREATE_EMPLOYEE_SUCCESS' : 'UPDATE_EMPLOYEE_SUCCESS',
          level: 'info',
          message: isNewEmployee ? `Створено співробітника "${employeeData?.RespName || ''}"` : 'Оновлено дані співробітника',
          storeCrmId: currentContactStore?.crmId,
          details: { name: employeeData?.RespName, email: employeeData?.RespEmail },
        });
        fetchCardsAndReference();
        // fetchData();
        message.success(isNewEmployee ? 'Співробітника створено' : 'Дані оновлено');
        push('/employees');
      })
      .catch((error) => {
        logUserAction({
          action: isNewEmployee ? 'CREATE_EMPLOYEE_ERROR' : 'UPDATE_EMPLOYEE_ERROR',
          level: 'error',
          message: error?.message || 'Помилка при збереженні співробітника',
          storeCrmId: currentContactStore?.crmId,
          details: { error: String(error) },
        });
        console.error('Помилка відправки:', error);
        message.error('Помилка збереження');
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmployee((prev) => ({
      ...prev,
      [name]: value, // Прямое обновление по оригинальным именам
    }));
    console.log(e.target);
  };

  const handlePositionChange = (value) => {
    const selectedPosition = reference.PlantEmployee.find((pos) => pos.value === value);
    setEmployee((prev) => ({
      ...prev,
      RespEmployeeJobId: selectedPosition || {}, // Обновляем объект employee
    }));
  };

  const handlePhotoUpload = (file) => {
    if (beforeUpload(file)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setEmployee((prev) => ({
          ...prev,
          attachFile1: e.target.result,
          attachFileName1: file.name,
        }));
      };
      reader.readAsDataURL(file);
    }
    return false;
  };

  const positions = Array.isArray(reference.PlantEmployee) ? reference.PlantEmployee : [];

  if (isLoading) {
    return (
      <Space className="loading" size="middle">
        <Spin size="large" />
      </Space>
    );
  }
  if (!employee && id) return <div>Співробітник не знайдений</div>;

  // Добавим подсчет элементов
  const targetId = '2ec4e1b9-b7f5-4eb2-9a83-695c9b1be716';
  const BLOCKED_STATUS_ID = '25405d2a-9df4-47a9-9313-fc8b4ca329fa';

  const targetCount = cards.filter((card) => card.RespSCAStatus.value === targetId).length;

  // Фильтруем карты исключая заблокированные
  const allCards = cards.filter((card) => card.RespSCAStatus?.value !== BLOCKED_STATUS_ID).length;

  return (
    <>
      <div className="box request-item-header" style={{ margin: '-10px 0 24px 0', zIndex: '2' }}>
        <div style={{ flex: 1, width: '100%' }}>
          <span className="text-grey-dark-normal-f16-l28">
            {isNewEmployee ? 'Створення співробітника' : 'Редагування співробітника'}
          </span>
        </div>
        <div className="cards-available">
          <span className="text-grey-dark-normal-f22-l28">Доступно карток: </span>
          <span className="text-black-bold-f24">
            <span style={{ color: 'rgb(219, 62, 177)' }}>
              {targetCount} {/* Количество элементов с нужным ID */}
            </span>
            з {allCards}
          </span>
        </div>
      </div>
      <div className="employee">
        <div className="box employee-box">
          <div className="employee-header__avatar-container">
            <img
              className="employee-header__avatar"
              src={blobContent || employee?.attachFile1 || '/images/profile-avatar.png'}
              alt="avatar"
            />
            <div className="employee-header__info">
              <div className="employee-header__name">
                {employee.RespName || employee.respName}{' '}
                {employee.RespSurName || employee.respSurName}
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
              >
                <div className="employee-header__email">
                  {employee?.RespEmail || employee?.respEmail}
                </div>
                <div className="employee-header__phone">
                  {formatPhoneNumber(employee?.RespMobilePhone || employee?.respMobilePhone)}
                </div>
                <div className="employee-header__email">
                  {isNewEmployee
                    ? employee?.position?.name
                    : employee?.RespEmployeeJobId?.displayValue}
                </div>
              </div>
            </div>
          </div>
          <div style={{ flexDirection: 'row', display: 'flex' }}>
            <EmployeeForm
              employee={employee || {}}
              beforeUpload={handlePhotoUpload}
              handleInputChange={handleInputChange}
              handlePositionChange={handlePositionChange}
              handleSubmit={handleSubmit}
              positions={positions}
              removePhoto={removePhoto}
              handleChangePhotoUpload={handleChangePhotoUpload}
              isNewEmployee={isNewEmployee}
              references={reference}
            />
            <EmployeeCard
              fetchData={fetchData}
              requests={requests}
              fetchCardsAndReference={fetchCardsAndReference}
              cardNumbers={cards}
              reference={reference}
              employee={employee}
              handleInputChange={handleInputChange}
              isNewEmployee={isNewEmployee}
              cardNumber={employee?.RespCardNumber}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeePage;
